import { Typography, withStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import illustration from '../../images/illustration-compte.png';
import IllustrationDroiteSvg from '../../images/illustration-droite';
import IllustrationGaucheSvg from '../../images/illustration-gauche';
import theme from '../../theme';
import styles from './style';

interface Props {
  classes?: any;
}

const ConfirmationRenouvellement = (props: Props) => {
  const { classes } = props;
  const themeColor = theme.palette.primary;
  const [status, setStatus] = useState<string>();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paiement = params.get('paiement');

    if (paiement === 'ok') {
      setStatus('success');
    } else if (paiement === 'ko') {
      setStatus('error');
    } else {
      setStatus(undefined);
    }
  }, [window.location.search]);

  return (
    <div className={classes.containerConfirmation}>
      <div className={`${classes.illustration} ${classes.rightIllustration}`}>
        <IllustrationDroiteSvg color1={themeColor.main} color2={themeColor.light} />
      </div>
      <div className={`${classes.illustration} ${classes.leftIllustration}`}>
        <IllustrationGaucheSvg color={themeColor.main} />
      </div>
      <div className={classes.title}>
        <Typography variant="h3">
          {status === 'success' ? 'Renouvellement confirmé' : 'Une erreur est survenue'}
        </Typography>
      </div>

      <div className={classes.container}>
        {status === 'success' &&
          'Votre demande de renouvellement a bien été prise en compte. Vous recevrez prochainement la confirmation'}
        {status === 'error' && 'Veuillez réessayer. Si le problème persiste, contacter Saga Service Plus.'}
      </div>
      <br />
      <img className={classes.illu} src={illustration} alt="Inscription" />
    </div>
  );
};

export default withStyles(styles)(ConfirmationRenouvellement);
